module.exports = __webpack_public_path__ + "Roboto-Regular.5136cbe62a63604402f2.woff2";


//////////////////
// WEBPACK FOOTER
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/node_modules/materialize-css/dist/fonts/roboto/Roboto-Regular.woff2
// module id = ../../../../materialize-css/dist/fonts/roboto/Roboto-Regular.woff2
// module chunks = vendor